<template>
  <div class="alert-history-empty-state">
    <div class="alert-history-empty-state-text">
      No alerts have been sent to this wallet yet.
    </div>
  </div>
</template>

<style lang="scss">
.alert-history-empty-state {
  min-height: 150px;
}

.alert-history-empty-state-text {
  font-size: 16px;
  font-weight: bold;
  padding: 50px 0px;
  text-align: center;
}
</style>
